// Full-document render of the sealy MattressFilterListPage (PLP):
// PageSkeleton (the React document shell) wrapping the hero, the existing
// page-body assembly, and the trailing store-locator panel.
import React from "react";

import { templates } from "@reactivated";

import { StoreLocator } from "../blocks/StoreLocator";
import { MattressFilterListPageBody } from "../components/MattressFilterListPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.MattressFilterListPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div className="product-grid-page__hero">
            {props.hero && (
                <>
                    <img
                        src={props.hero.image_url}
                        width={props.hero.image_width}
                        height={props.hero.image_height}
                        alt={props.hero.image_alt}
                        fetchPriority="high"
                    />
                    {/* The hero's inner <div> is class-less; its children
                        (h1 + raw description + optional CTA) arrive as one
                        server-built HTML string -- see
                        MattressFilterListPageHero in server/cms/templates.py
                        for why they can't be separate elements here. */}
                    <div
                        dangerouslySetInnerHTML={{
                            __html: props.hero.content_html,
                        }}
                    />
                </>
            )}
        </div>
        <MattressFilterListPageBody page={props.page} />
        {/* The value-less store-locator panel; the component ignores its
            block value (the legacy include rendered it with value=None). */}
        <StoreLocator value={null} />
    </PageSkeleton>
);
